
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Fault-Index',
})
